import AppId from '@/util/appid'
import IncorrectAuthenticationDataError from '@spa/components/pages/auth/login/components/error/IncorrectAuthenticationDataError.vue'
import TooManyRequestedError from '@spa/components/pages/auth/login/components/error/TooManyRequestedError.vue'
import UnexpectedError from '@spa/components/pages/auth/login/components/error/UnexpectedError.vue'
import DefaultNote from '@spa/components/pages/auth/login/components/note/DefaultNote.vue'
import MyColorNote from '@spa/components/pages/auth/login/components/note/MyColorNote.vue'
import ShortcutLoginArea from '@spa/components/pages/auth/login/components/shortcut/ShortcutLoginArea.vue'
import { State } from '@spa/components/pages/auth/login/model/state'
import Vue, { VueConstructor } from 'vue'

export interface LoginPageParts {
  readonly note: VueConstructor
  readonly shortcut: VueConstructor
  readonly error: VueConstructor
}

export const setUpForState = (appId: string) => (status: State): LoginPageParts => {
  switch (status) {
    case 'failed-too-many-requested':
      return {
        ...setupForHost(appId),
        error: TooManyRequestedError,
      }

    case 'failed-incorrect-authentication':
      return {
        ...setupForHost(appId),
        error: IncorrectAuthenticationDataError,
      }

    case 'failed-not-initialized-yet':
    case 'failed-unknown':
      return {
        ...setupForHost(appId),
        error: UnexpectedError,
      }

    default:
      return setupForHost(appId)
  }
}

const empty = Vue.extend({
  name: 'EmptyLoginPart',
  template: '<div></div>',
})

function setupForHost(hostId: string): LoginPageParts {
  switch (hostId) {
    case AppId.getByHostName('mycolor'):
      return {
        note: MyColorNote,
        shortcut: ShortcutLoginArea,
        error: empty,
      }
    default:
      return {
        note: DefaultNote,
        shortcut: empty,
        error: empty,
      }
  }
}
